
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50.5 50.499"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":".5"}},[_c('path',{attrs:{"d":"M50.25 2.75a2.5 2.5 0 00-2.5-2.5h-45a2.5 2.5 0 00-2.5 2.5v45a2.5 2.5 0 002.5 2.5h45a2.5 2.5 0 002.5-2.5z"}}),_c('path',{attrs:{"d":"M19.769 34.672a1.349 1.349 0 01-2-1.176V16.619a1.347 1.347 0 012.013-1.168l14.775 8.443a1.344 1.344 0 010 2.336z"}})])])
          )
        }
      }
    